import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=00a29373&scoped=true&"
import script from "./DialogBase.vue?vue&type=script&lang=js&"
export * from "./DialogBase.vue?vue&type=script&lang=js&"
import style0 from "./DialogBase.vue?vue&type=style&index=0&id=00a29373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a29373",
  null
  
)

/* custom blocks */
import block0 from "./DialogBase.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports